<template>
  <div v-if="haveLoad">
    <admin-controls v-if="$user.isAdminOrCoordinator"></admin-controls>

    <template v-if="jobIsEditable">
          <ul class="nav nav-actions">
              <li><a data-toggle="modal" data-target=".modal-email-driver"><i class="fa fa-send"></i> Email driver</a></li>
              <li><a data-toggle="modal" data-target=".modal-sms-driver"><i class="fa fa-send"></i> SMS driver</a></li>
          </ul>

      <email-modal></email-modal>
      <sms-modal></sms-modal>
    </template>

    <load-overview></load-overview>

        <div class="ibox" v-if="$user.isNotAdmin">
            <div class="ibox-title">
                <h2>Additional Charges</h2>
            </div>
            <div class="ibox-content">
                <ul class="list-detail list-detail-additional-charges">
                  <li v-show="haveNoDecoratedCharges">
                    <div class="text-center text-muted">
                      <strong>No additional charges.</strong>
                    </div>
                  </li>
                    <li v-for="charge in loadDecorated.charges">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-7">
                                {{ charge.description }}
                            </div>
                            <div class="col-xs-6 col-sm-4 col-md-2">
                                {{ $user.isCarrierOrDriver ? charge.carrier_rate : charge.client_rate  }}
                            </div>
                            <div class="col-xs-6 col-sm-4 col-md-2">
                                {{ charge.type }}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

    <div class="ibox">
      <div class="ibox-title">
        <h2>Weighbridge Details</h2>
      </div>
      <div class="weighbridge-details-collapse collapse">
        <div class="ibox-content ibox-content-padding-xs">

          <weighbridge-details></weighbridge-details>
        </div>
      </div>

      <div class="ibox-footer ibox-footer-weighbridge-control text-center" data-toggle="collapse" data-target=".weighbridge-details-collapse" aria-expanded="false">
        <i class="fa fa-chevron-down"></i>
      </div>
    </div>

        <div v-if="loadDecorated.location_from && loadDecorated.location_to" class="ibox">
            <div class="ibox-title">
                <h2 class="transportation-information">
                    Locations
                    <a class="get-directions" target="_blank" :href="`https://www.google.com.au/maps/dir/?api=1&origin=${loadDecorated.location_from.latitude},${loadDecorated.location_from.longitude}&destination=${loadDecorated.location_to.latitude},${loadDecorated.location_to.longitude}`">
                        <i class="fa fa-level-down"></i>
                    </a>
                </h2>
            </div>
            <div class="ibox-content ibox-content-padding-xs">
                <div class="row">
                    <div class="col-lg-6 m-b-md">

                        <div class="row">
                            <div class="col-xs-2 col-md-1">
                                <a class="location-map-link" target="_blank" :href="`https://www.google.com.au/maps/search/?api=1&query=${loadDecorated.location_from.latitude},${loadDecorated.location_from.longitude}`">
                                    <i class="fa fa-map-marker"></i>
                                </a>
                            </div>
                            <div class="col-xs-10 col-md-11">
                                <p class="material-details">
                                    <span class="title">From</span><br />
                                    {{ loadDecorated.location_from.formattedName }}
                                    <small>{{ loadDecorated.location_from.address}}</small>
                                    <small>Lat: {{ loadDecorated.location_from.latitude }}, Long: {{ loadDecorated.location_from.longitude }}</small>
                                </p>
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-offset-1 col-md-11">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <p class="material-details">
                                            <strong>Location Contact</strong><br />
                                            {{ loadDecorated.location_from.contact_name }}
                                        </p>
                                    </div>
                                    <div class="col-xs-6">
                                        {{ loadDecorated.location_from.contact_phone }} <br />
                                    </div>
                                    <div class="col-xs-6">
                                        {{ loadDecorated.location_from.contact_secondary_phone }} <br />
                                    </div>
                                    <div class="col-xs-6">
                                        {{ loadDecorated.location_from.uhf_channel ? `UHF ${loadDecorated.location_from.uhf_channel}` : '' }}
                                    </div>
                                    <div class="col-xs-12">
                                        <p class="truncate">
                                            <a href="`mailto:${loadDecorated.location_from.contact_email}`">{{ loadDecorated.location_from.contact_email }}</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-offset-1 col-md-11">
                                <p class="material-details">
                                    <strong>Hours of Loading</strong><br />
                                    {{ loadDecorated.location_from.hours_of_loading }}
                                </p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-offset-1 col-md-11">
                                <p class="material-details">
                                    <strong>Access Instructions</strong><br />
                                    {{ loadDecorated.location_from.directions }}
                                </p>

                <a v-if="loadDecorated.location_from.photo_url" :href="loadDecorated.location_from.photo_url" target="_blank" class="btn btn-xs btn-info">View Image &nbsp; <i class="fa fa-expand"></i></a>
                            </div>
                        </div>

                    </div>
                    <div class="col-lg-6 m-b-md">

                        <div class="row">
                            <div class="col-xs-2 col-md-1">
                                <a class="location-map-link" target="_blank" :href="`https://www.google.com.au/maps/search/?api=1&query=${loadDecorated.location_to.latitude},${loadDecorated.location_to.longitude}`">
                                    <i class="fa fa-map-marker"></i>
                                </a>
                            </div>
                            <div class="col-xs-10 col-md-11">
                                <p class="material-details">
                                    <span class="title">To</span><br />
                                    {{ loadDecorated.location_to.formattedName }}
                                    <small>{{ loadDecorated.location_to.address }}</small>
                                    <small>Lat: {{ loadDecorated.location_to.latitude }}, Long: {{ loadDecorated.location_to.longitude }}</small>
                                </p>
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-offset-1 col-md-11">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <p class="material-details">
                                            <strong>Location Contact</strong><br />
                                            {{ loadDecorated.location_to.contact_name }}
                                        </p>
                                    </div>
                                    <div class="col-xs-6">
                                        {{ loadDecorated.location_to.contact_phone }} <br />
                                    </div>
                                    <div class="col-xs-6">
                                        {{ loadDecorated.location_to.contact_secondary_phone}} <br />
                                    </div>
                                    <div class="col-xs-6">
                                        {{ loadDecorated.location_to.uhf_channel ? `UHF ${loadDecorated.location_to.uhf_channel}` : '' }}
                                    </div>
                                    <div class="col-xs-12">
                                        <p class="truncate">
                                            <a :href="`mailto:${loadDecorated.location_to.contact_email}`">{{ loadDecorated.location_to.contact_email }}</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

            <div class="row">
                            <div class="col-md-offset-1 col-md-11">
                                <p class="material-details">
                                    <strong>Hours of Loading</strong><br />
                                    {{ loadDecorated.location_to.hours_of_loading }}
                                </p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-offset-1 col-md-11">
                                <p class="material-details">
                                    <strong>Access Instructions</strong><br />
                                    {{ loadDecorated.location_to.directions }}
                                </p>

                                <a v-if="loadDecorated.location_to.photo_url" :href="loadDecorated.location_to.photo_url" target="_blank" class="btn btn-xs btn-info">View Image &nbsp; <i class="fa fa-expand"></i></a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    <distance-map ref="map" :location-from="loadDecorated.location_from" :location-to="loadDecorated.location_to"></distance-map>

        <div class="text-right m-t-lg m-b-lg">
            <ladda-button
        v-if="canWithdrawFromLoad"
        :on-click="handleWithdrawFromLoad"
        class="btn btn-sm btn-danger">
        <i class="fa fa-times"></i> Withdraw
      </ladda-button>

      <ladda-button
        v-if="canCancelLoad"
        :on-click="handleCancelLoad"
        class="btn btn-sm btn-danger">
        <i class="fa fa-times"></i> Cancel
      </ladda-button>
        </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
  import { LaddaButton, Selectize, DateRange } from 'components/forms'
  import { SET_LOAD_ATTRIBUTE, SET_JOB, RESET_LOAD } from 'vx/mutations'
  import { stateMapper } from 'mixins/loads'
  import { jobHelpers } from 'mixins/jobs'
  import { notify, alert } from 'utils'
  import DistanceMap from 'components/jobs/DistanceMap'
  import WeighbridgeDetails from './weighbridge/WeighbridgeDetails'
  import LoadOverview from './LoadOverview'
  import EmailModal from './EmailModal'
  import SmsModal from './SmsModal'
  import AdminControls from './AdminControls'

  export default {
    mixins: [stateMapper, jobHelpers],

    components: {
      LaddaButton,
      Selectize,
      DateRange,
      DistanceMap,
      WeighbridgeDetails,
      LoadOverview,
      EmailModal,
      SmsModal,
      AdminControls
    },

    created () {
      this[RESET_LOAD]()

      const loadNotFound = () => {
        notify.error('Load could not be found.')

        this.$router.push({ name: 'loads.index' })
      }

      this.getLoad(this.$route.params.id)
        .then(() => {
          this[SET_JOB](this.load.job)
        })
        .catch(loadNotFound)
    },

    computed: {
      ...mapGetters('load', ['loadDecorated', 'haveLoad']),
      ...mapGetters('truck', ['truckOptionsWithNone']),
      ...mapGetters('driver', ['driverOptionsWithNone']),
      ...mapGetters('user', ['userOptions']),
      ...mapState('load', ['load']),

      /**
       * Determine if this load has no additional charges.
       *
       * @return boolean
       */
      haveNoDecoratedCharges () {
        return !this.load.charges.length
      },

      /**
       * Determine if the logged in user is the one assigned to the load.
       *
       * @return boolean
       */
      isAssignedCarrier () {
        return this.$user.id === this.load.carrier_id
      },

      /**
       * Determine if we can withdraw from load.
       *
       * @return boolean
       */
      canWithdrawFromLoad () {
        return this.isAssignedCarrier && this.jobIsEditable
      },

      /**
       * Determine if we can cancel the load.
       *
       * @return boolean
       */
      canCancelLoad () {
        if (this.$user.isCarrier) {
          return false
        }

        return this.$user.canManageLoads && this.jobIsEditable && this.load.status !== 'cancelled'
      }
    },

    methods: {
      ...mapMutations('job', [SET_JOB]),
      ...mapMutations('load', [SET_LOAD_ATTRIBUTE, RESET_LOAD]),
      ...mapActions('load', ['getLoad', 'withdrawFromLoad', 'cancelLoad']),

      /**
       * Handle carrier withdrawing from a load.
       *
       * @return Promise
       */
      handleWithdrawFromLoad () {
        return alert.delete({ text: 'Are you sure you want to withdraw from this load?' }).then(() => {
          const redirectToLoads = () => {
            this.$router.push({ name: 'loads.index' })
          }

          return this.withdrawFromLoad(this.load.id).then(redirectToLoads)
        })
      },

      /**
       * Handle admin/coordinator cancelling load.
       *
       * @return Promise
       */
      handleCancelLoad () {
        return alert.delete({ text: 'Are you sure you want to permanently cancel this load?' }).then(() => {
          return this.cancelLoad(this.load.id)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Show.vue?aa9281fa